import Search from "@common/controls/Inputs/Search/component";
import { useI18n } from "@common/hooks/i18n";
import { useNavigation } from "@common/hooks/navigation";
import { parseQueryString } from "@common/lib/url";
import React from "react";

export interface ExpandableSearchProps {
  debounceMs?: number;
  inputClassName?: string;
  onSearch: (text: string) => void | Promise<void>;
  shouldSyncToQs?: boolean;
  style?: React.CSSProperties;
  text: string;
}
const ExpandableSearch = (props: ExpandableSearchProps) => {
  const i18n = useI18n();

  const navigation = useNavigation();
  const searchPromise = React.useRef<Promise<void> | null>(null);

  const triggerSearch = React.useCallback(
    async (text: string) => {
      if (props.shouldSyncToQs) {
        const qs = parseQueryString(location.search);
        qs.search = text;
        if (!qs.search) delete qs.search;
        // IMPORTANT: this doesn't modify history
        navigation.setQuery(qs, { isReplace: true });
      }

      if (searchPromise) await searchPromise.current;

      const pl = props.onSearch(text);
      if (pl instanceof Promise) {
        searchPromise.current = pl;
        await pl;
      }
    },
    [props.onSearch, props.shouldSyncToQs]
  );

  return (
    <Search
      className="expandable_search"
      inputClassName={props.inputClassName}
      onChange={triggerSearch}
      onChangeTrigger={props.debounceMs}
      placeholder={i18n.search}
      style={props.style}
      value={props.text}
    />
  );
};

export default ExpandableSearch;
